import { NavLink } from "react-router-dom";
import { LayoutDashboard, ShoppingBag, Layers, Wallet, User as UserIcon } from "lucide-react";
import clsx from "clsx";

const BOTTOM_NAV = [
  { to: "/dashboard",        label: "Home",     icon: LayoutDashboard },
  { to: "/dashboard/catalog",label: "Store",  icon: ShoppingBag },
  { to: "/dashboard/entries",label: "My Club",  icon: Layers },
  { to: "/dashboard/wallet", label: "Wallet",   icon: Wallet },
  { to: "/dashboard/profile",label: "Profile",  icon: UserIcon },
];

export function BottomNav() {
  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-surface-200 pb-safe shadow-[0_-4px_20px_-10px_rgba(0,0,0,0.1)]">
      <div className="flex items-center justify-around px-2 h-16">
        {BOTTOM_NAV.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/dashboard"}
            className={({ isActive }) => clsx(
              "flex flex-col items-center justify-center w-full h-full space-y-1 transition-colors",
              isActive 
                ? "text-brand-600" 
                : "text-surface-400 hover:text-surface-600"
            )}
          >
            {({ isActive }) => (
              <>
                <div className={clsx(
                  "p-1.5 rounded-xl transition-all duration-300",
                  isActive ? "bg-brand-50" : "bg-transparent"
                )}>
                  <Icon className={clsx("h-5 w-5", isActive && "fill-brand-100/50")} strokeWidth={isActive ? 2.5 : 2} />
                </div>
                <span className={clsx("text-[10px] font-semibold", isActive ? "text-brand-600" : "text-surface-500")}>
                  {label}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}